var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.535,
    height: 17.797,
    viewBox: "0 0 14.535 17.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_4_",
    "data-name": "delete (4)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M14.49,3.978,14.1,2.8a1.1,1.1,0,0,0-1.041-.75h-3.3V.975A.976.976,0,0,0,8.779,0H5.755a.976.976,0,0,0-.974.975V2.05h-3.3A1.1,1.1,0,0,0,.437,2.8L.045,3.978A.882.882,0,0,0,.881,5.139h.411l.9,11.179A1.617,1.617,0,0,0,3.8,17.8h7.121a1.617,1.617,0,0,0,1.6-1.479l.9-11.179h.227a.882.882,0,0,0,.836-1.161ZM5.824,1.043H8.711V2.05H5.824Zm5.659,15.191a.569.569,0,0,1-.563.521H3.8a.569.569,0,0,1-.563-.521l-.9-11.095H12.38ZM1.1,4.1l.322-.966a.054.054,0,0,1,.052-.037H13.056a.054.054,0,0,1,.052.037l.322.966Zm0,0",
    transform: "translate(0 0)",
    fill: "#C81E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M268.79,176.017h.028a.521.521,0,0,0,.52-.494l.49-9.4a.521.521,0,0,0-1.041-.054l-.489,9.4A.521.521,0,0,0,268.79,176.017Zm0,0",
    transform: "translate(-258.97 -159.821)",
    fill: "#C81E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M106.307,175.527a.521.521,0,0,0,.52.493h.029a.521.521,0,0,0,.492-.549l-.513-9.4a.521.521,0,1,0-1.041.057Zm0,0",
    transform: "translate(-102.117 -159.823)",
    fill: "#C81E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M194.775,176.02a.521.521,0,0,0,.521-.521v-9.4a.521.521,0,0,0-1.043,0v9.4A.521.521,0,0,0,194.775,176.02Zm0,0",
    transform: "translate(-187.502 -159.823)",
    fill: "#C81E1E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f76639f989ed73d9c67207c0e5795182.svg";
export { ForwardRef as ReactComponent };